import React from 'react';
import ReactDOM from 'react-dom/client';
import appConfig from './config.js';

let GameProviderComponent;
let AppComponent;

let selectedVersion = appConfig.currentVersion;
const path = window.location.pathname;

if (path.includes('/v1/')) {
  selectedVersion = 'v1';
} else if (path.includes('/v2/')) {
  selectedVersion = 'v2';
}

try {
  if (selectedVersion === 'v2') {
    GameProviderComponent = require('./v2/context/GameContext.jsx').GameProvider;
    AppComponent = require('./v2/App.jsx').default;
  } else {
    GameProviderComponent = require('./v1/context/GameContext.jsx').GameProvider;
    AppComponent = require('./v1/App.jsx').default;
  }
} catch (error) {
  console.error(`Error loading modules for version '${selectedVersion}':`, error);
  console.warn(`Please ensure that App.jsx and GameContext.jsx for the selected version exist in the correct paths. Attempting fallback to v1.`);

  try {
    GameProviderComponent = require('./v1/context/GameContext.jsx').GameProvider;
    AppComponent = require('./v1/App.jsx').default;
    console.warn(`Successfully fell back to v1.`);
  } catch (fallbackError) {
    console.error(`Failed to load v1 modules during fallback:`, fallbackError);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GameProviderComponent>
      <AppComponent />
    </GameProviderComponent>
  </React.StrictMode>,
);